
const name = 'form-newsletter';

export default class FormNewsletter {

  constructor ($el) {
    this.$el = $el;
    this.required = $el.classList.contains(`${name}--required`);
    this.valid = true;
    this.delegate = null;

    // Bind elements
    this.$message = $el.querySelector(`.${name}__message`);
    this.$input = $el.querySelector(`.${name}__input`);

    // Get field name
    this.name = this.$input.name;

    // Bind events and call initial change event
    this.$input.oninput = this.onChange.bind(this);
    this.$input.onchange = this.onChange.bind(this);
    this.$input.onblur = this.onBlur.bind(this);
    this.onChange();
  }

  /**
   * Sets this field's delegate.
   * @param {object} delegate
   * @return this
   */
  setDelegate (delegate) {
    this.delegate = delegate;

    return this;
  }

  /**
   * Triggered when losing focus.
   */
  onBlur () {
    // Trigger validation when leaving field
    this.validate();
  }

  /**
   * Triggered on value change.
   */
  onChange () {
    // Validate on every change when field is currently invalid
    if (!this.valid) {
      this.validate();
    }
  }

  /**
   * Returns field name.
   * This method gets called from the parent form instance.
   * @return {string} Field name
   */
  getName () {
    return this.name;
  }

  /**
   * Returns field value.
   * This method gets called from the parent form instance.
   * @return {string} Field value
   */
  getValue () {
    return this.$input.checked;
  }

  /**
   * Returns wether this field is valid.
   * This method gets called from the parent form instance.
   * @return {boolean}
   */
  isValid () {
    return this.valid;
  }

  /**
   * Validates field.
   * This method gets called from the parent form instance.
   * @return {boolean}
   */
  validate () {
    const value = this.getValue();

    // Check if checking is required
    const valid = !this.required || (this.required && value);
    this.setValid(valid);

    return this.isValid();
  }

  /**
   * Sets wether this field is valid.
   * @param {boolean} valid
   */
  setValid (valid) {
    if (this.valid !== valid) {
      this.valid = valid;

      // Update invalid modifier
      this.$el.classList.toggle(`${name}--invalid`, !valid);

      // Inform delegate about this
      this.delegate && this.delegate.fieldValidDidChange(this, valid);
    }

    return this;
  }
}
